import { HTMLProps } from 'react';
import './FooterCertLogos.scss';

export const FooterCertLogos = (props: HTMLProps<HTMLDivElement>) => (
  <div className={`${props.className} footer-cert-logos`}>
    <img
      alt='GRC Logo'
      src='https://rizosrealty.blob.core.windows.net/site-content/images/GRC_logo.webp'
    />
    <img
      alt='Realtor Union Logo'
      src='https://rizosrealty.blob.core.windows.net/site-content/images/realtor_union_logo.webp'
    />
    <img
      alt='CEPI Logo'
      src='https://rizosrealty.blob.core.windows.net/site-content/images/cepi%20logo.webp'
    />
  </div>
);
